<template>
  <v-btn
    data-qa="appointment_submit_button"
    color="primary"
    elevation="0"
    :class="{ 'appointment-button_club-gradient': isClubEnabled }"
    :disabled="!familyProfilesStore.isFamilyRequestDone || (lpuDataStore.isTelemedMedical && familyProfilesStore.isUnderagePatient)"
    block
    @click="emit('click:appointment')"
  >
    <slot>
      <template v-if="appointmentDataStore.appointmentRegistrationTypes.isExpress">
        {{ $t('Заказать звонок', options) }}
      </template>
      <template v-else-if="appointmentDataStore.isAnyTelemed">
        {{ $t('Продолжить', options) }}
      </template>
      <template v-else-if="isClubEnabled">
        Перейти к оплате {{ onlinePriceClub }}
      </template>
      <template v-else>
        {{ $t('Записаться', options) }}
      </template>
    </slot>
  </v-btn>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import getUserLanguage from 'src/utils/getUserLanguage'
import formatPrice from 'src/functions/formatPrice'
import useFamilyProfilesStore from 'www/vue_components/common/FamilyProfiles/stores/useFamilyProfilesStore'
import {
  useAppointmentDataStore,
} from 'www/vue_components/common/AppointmentPage/stores'
import useLpuDataStore from 'www/vue_components/common/AppointmentPage/stores/useLpuDataStore'

const props = defineProps<{
  optionPrice?: number | null
  cardPrice?: number | null
  isClubEnabled?: boolean
}>()

type Emits = {
  (_event: 'click:appointment'): void
}

const emit = defineEmits<Emits>()

const options = { ns: getUserLanguage() }

const appointmentDataStore = useAppointmentDataStore()
const familyProfilesStore = useFamilyProfilesStore()
const lpuDataStore = useLpuDataStore()

const onlinePriceClub = computed(() => formatPrice({
  price: (props.optionPrice ?? 0) + (props.cardPrice ?? 0),
  currencySymbol: window.CURRENCY_DATA.symbol,
}))
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.appointment-button {
  &_club-gradient {
    background-color: $ui-kit-text-warning;
    background-image: $ui-kit-club-gradient;
  }
}
</style>
